
import { Product } from "@/types/product";

export const ipxTS3ACFPRO: Product = {
  id: "ipx-ts3a-cf-pro",
  groupId: "avoip",
  name: "IPX-TS3A-CF-PRO",
  subtitle: "10Gb Box Transceiver",
  description: "The IPX-TS3A-CF-PRO is a professional-grade 10G AV over IP transceiver that sets new standards for AV distribution performance. This versatile unit features both copper and fiber network interfaces, offering maximum flexibility for various installation requirements. Supporting true 4K60 4:4:4 video with zero compression and zero latency, it delivers uncompromised video quality for the most demanding applications.\n\nBuilt on SDVoE Technology, this transceiver can simultaneously transmit and receive, making it incredibly versatile for complex system designs. The unit includes an option slot for USB 2.0 or Dante® integration, providing enhanced connectivity options for various applications.\n\nThe IPX-TS3A-CF-PRO is ideal for high-end installations requiring the absolute best in video quality and system flexibility, such as broadcast facilities, command and control centers, and premium corporate environments.",
  features: [
    "Simultaneous 4K transmit and receive on one cable",
    "4K60 4:4:4 Over 10G Fiber or Copper",
    "Zero Compression/Frame Latency (22us) for 4K60 4:2:0 and below",
    "1.3:1 Lossless Compression and Zero Frame Latency (100us) for 4K60 4:4:4",
    "Includes 10Gbps fiber MMF/SMF & 10Gbps copper ports",
    "Network Redundant operation",
    "Secure Content Encryption",
    "128x128 Capable with HDCP, Larger for Non-Encrypted Sources",
    "Video Wall Capability 8x8",
    "Windowing/Multi-viewer up to 32 windows",
    "3ms Scaling",
    "Seamless Switching",
    "Break-away Switching",
    "Audio DSP",
    "SFP+ for Multi/Single Mode Fiber",
    "Front Keypad with OLED Display"
  ],
  specifications: [
    "Video Compression: Zero (4K30 4:4:4/4K60 4:2:0), 1.3:1(4K60 4:4:4)",
    "Latency: Zero Frame Latency (100us without Scaling, 3ms with Scaling)",
    "Bandwidth: 600MHz",
    "HDCP: HDCP 2.2",
    "HDMI: 2 Inputs, 1 Output",
    "Analog Audio: Stereo Line In/Out (3.5mm TRS Tip is Left, Ring is Right, Sleeve is Ground)",
    "10G Ethernet: (1) 10G Copper RJ-45 330ft CAT 6A PoE+ & (1) 10G Fiber SFP+",
    "1G Ethernet: (1) 10/100/1000M PoE+ (PSE)",
    "RS-232: Up to 115k Baud (3.5mm TRS Tip TX, Ring RX, Sleeve Ground)",
    "IR: Bi-Directional (3.5mm TRS Tip TX, Ring 5V, Sleeve Ground)",
    "USB: 2 x USB 2.0 Type A, 1 x USB 2.0 Micro",
    "Expansion Cards: ExtremeUSB, Dante and ReAX Options",
    "Webserver: Built-In Control Server",
    "Management Software: IPBaseT Manager (free download)",
    "3rd Party Control: Comprehensive Telnet API including Exclusive Aurora Wrapper Functions",
    "Housing: Black Aluminum Enclosure",
    "Dimensions [L x W x H]: 175 x 102 x 27.7mm [6.875\" x 4\" x 1.09\"]",
    "Weight: 0.453kg [1.0lbs]",
    "Mount: Optional: Rack mount vertical, Rack mount horizontal, Under table mount",
    "Power Supply: PoE on 1G or 10G LAN ports",
    "Power Consumption: 12.9 Watts",
    "Operating Temperature: 0 ~ 40 Celsius [32 ~ 100 Farenheit]",
    "Storage Temperature: -20 ~ 60 Celsius [-4 ~ 140 Farenheit]",
    "Relative Humidity: 20~90% RH [no condensation]"
  ],
  images: [
    "/lovable-uploads/e6180279-6d67-449a-af86-d53f79a8d53c.png",
    "/lovable-uploads/88ec8870-2299-483a-89ed-f97c2c476623.png"
  ],
  videoUrl: "https://youtu.be/T_GmvE3ExoE?si=4mNv77MwcggNB8sA",
  slug: "ipx-ts3a-cf-pro",
  networkSpeed: "10gb"
};
